import React, { useEffect, useState } from "react";
import { Modal, Box, Typography, Button } from "@mui/material";
import { ReactComponent as Warning } from "assets/Warning.svg";
import { useTranslation } from "react-i18next";

const AuditConfirmModal = ({
  questionType,
  activeQuestion,
  open,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const [modalDescription, setModalDescription] = useState(
    t("questionnaireSetup.modal.child")
  );

  useEffect(() => {
    if (activeQuestion) {
      if (questionType === "calculated") {
        setModalDescription(t("questionnaireSetup.modal.calculated"));
      } else if (questionType === "validated") {
        setModalDescription(t("questionnaireSetup.modal.validated"));
      } else if (questionType === "child") {
        setModalDescription(t("questionnaireSetup.modal.child"));
      }
    } else {
      setModalDescription(t("questionnaireSetup.modal.inactive"));
    }
  }, [questionType, activeQuestion]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="template-download-warning"
      aria-describedby="template-download-warning-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          borderRadius: "10px",
          padding: "30px 10px",
          maxWidth: "400px",
          width: "90%",
          textAlign: "center",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.2)",
          outline: "none",
        }}
      >
        {/* Failed Icon */}

        <Box sx={{ mb: "-30px" }}>
          <Warning
            style={{ width: "161px", height: "149px", margin: "0 auto" }}
          />
        </Box>

        {/* Warning Message */}
        <Typography
          id="template-download-warning-description"
          sx={{
            color: "#333",
            fontSize: "16px",
            lineHeight: 1.5,
            fontFamily: "Montserrat",
            fontWeight: 500,
            maxWidth: "300px",
            margin: "0 auto",
          }}
        >
          {modalDescription}
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
          <Box
            sx={{
              display: "flex",
              width: "67%",
              justifyContent: "space-around",
            }}
          >
            <Button
              onClick={onClose}
              sx={{
                display: !activeQuestion && "none",
                backgroundColor: "gray",
                color: "white",
                borderRadius: "10px",
                padding: "7px 26px",
                fontSize: "16px",
                fontWeight: "500",
                textDecoration: "",
                fontFamily: "Montserrat",
                minWidth: "100px",
                "&:hover": {
                  backgroundColor: "lightgray",
                },
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              }}
            >
              {t("questionnaireSetup.cancel")}
            </Button>

            <Button
              onClick={activeQuestion ? onConfirm : onClose}
              sx={{
                backgroundColor: "#EF7D00",
                color: "white",
                borderRadius: "10px",
                padding: "7px 26px",
                fontSize: "16px",
                fontWeight: "500",
                fontFamily: "Montserrat",
                minWidth: "100px",
                "&:hover": {
                  backgroundColor: "#d66d00",
                },
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
              }}
            >
              {t("questionnaireSetup.ok")}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AuditConfirmModal;
